// extracted by mini-css-extract-plugin
export default {"loaderContainer":"AppLoader-module__loaderContainer--dOSBm","pageLoader":"AppLoader-module__pageLoader--r6qTN"};